import { styled } from '../../../theme/stitches.config';

export const SMPOddEntity = styled.withConfig({ componentId: 'CommonWidget', displayName: 'OddEntity' })('a', {
  boxSizing: 'border-box',
  display: 'flex',
  fontFamily: '$primaryFontFamily',
  textDecoration: 'none',
  outline: 'none',
  variants: {
    variant: {
      odd: {
        flex: '1 1 auto',
        bc: '$oddItemPrimaryBgColor',
        br: '$1',
        px: '$2',
        py: '$1',
        '&:hover': {
          bc: '$accentPrimaryBgColor',
          cursor: 'pointer',
        },
      },
    },
  },
});
